import router from '@/router/';
import store from '@/store/';

import { pointInPolygon } from '@/utils/funciones_auxiliares.js';
import { formatearDireccionGoogle } from '@/utils/funciones_auxiliares.js';
import { db } from '@/firebase'
import _ from 'lodash'

export default {
    localizarTextoInput({ commit, rootState, state, dispatch }, dir) {
        let address = "";
        let locationEntries = state.locationEntries;
        let noselocaliza = false;
        if (locationEntries.length > 0) {
            noselocaliza = locationEntries[0]['value'].includes(
                "No se localiza. Escribir a mano."
            );
        }
        var modo = state.modoEligiendo;
        var inputString
        switch (modo) {
            case "recoger":
                //commit('setDirRecogerInput', (dir) ? dir.value : locationEntries[0].value);
                inputString = state.dirRecogerInput;
                break;

            case "domicilio":
                //commit('setDirDomicilioInput', (dir) ? dir.value : locationEntries[0].value);
                inputString = state.dirDomicilioInput;
                break
        }
        /** tomamos la dirección que hemos pasado */
        var inputString = (dir) ? dir.value : '';
        if (!state.buscando) {
            commit("setBuscando", true);
            let inputVacio = (inputString) ? inputString.length == 0 : false;
            if (inputVacio) {
                commit("snackbar/setMensajeInfo",
                    { msj: "Pruebe de nuevo" },
                    { root: true }
                );

                commit("setBuscando", false);
            } else {

                if (modo == "domicilio") { //para domicilio
                    if (noselocaliza) {
                        dispatch('openDialogDireccion', { open: true, dir: {} })
                            .then(() => {
                            })
                    } else if (locationEntries[0]) {
                        let geocoder = new google.maps.Geocoder();
                        geocoder.geocode({
                            'address': inputString,
                            'componentRestrictions': { country: 'ES' }
                        }, function (results, status) {
                            if (status == 'OK') {
                                commit('setDirDomicilioInputObj', {
                                    ...formatearDireccionGoogle(results[0].address_components),
                                    coordenadas: [results[0].geometry.location.lat(), results[0].geometry.location.lng()],
                                    tipo: 'input'
                                });
                                commit('setDirDomicilioInput', inputString);
                                dispatch('openDialogDireccion', { open: true, dir: state.dirDomicilioInputObj })
                                    .then(() => {
                                    })
                                commit("setBuscando", false);
                                dispatch('reorderRestaurants').finally(() => {
                                    commit("setBuscando", false);
                                })
                            } else if (status === 'INVALID_REQUEST') {
                                commit("setBuscando", false);
                            } else {
                                commit("setBuscando", false);
                            };
                        });
                    } else {
                        commit("setBuscando", false);
                    }

                } else { //para recoger
                    if (locationEntries[0]) {
                        let geocoder = new google.maps.Geocoder();
                        geocoder.geocode({
                            'address': inputString,
                            'componentRestrictions': { country: 'ES' }
                        }, function (results, status) {
                            if (status == 'OK') {
                                let coord = {
                                    lat: results[0].geometry.location.lat(),
                                    lng: results[0].geometry.location.lng()
                                };
                                commit('setDirRecogerInputCoordenadas', coord);
                                commit('setDirRecogerProveedor', 'input');
                                commit("setDirRecogerInput", inputString);
                                commit("setDirRecogerInputObj", locationEntries[0]);

                                dispatch('reorderRestaurants').finally(() => {
                                    commit("setBuscando", false);
                                })
                            } else if (status === 'INVALID_REQUEST') {
                                commit("setBuscando", false);
                            } else {
                                commit("setBuscando", false);
                            };
                        });
                    } else {
                        commit("setBuscando", false);
                    }
                }
            }
        }
    },
    cargarLogicaRecoger({ commit, rootState, state, dispatch, rootGetters }, payload) {
        let _vue = this;
        let dirPidiendo = rootState.pedido.direccionPedido;
        let user = rootState.auth.user;
        let ultimaDireccion = rootGetters['auth/ultimaDireccionUsada'];
        let isLogged = rootState.auth.isLogged;
        const vieneDePedidos = state.vieneDePedidos
        if (vieneDePedidos && state.dirRecogerInput.length > 0) {
            //viene de pedidos
        } else if (!isLogged || !ultimaDireccion) {
            //geolocalizar
            commit('setLoadingRest', true)
            if ("geolocation" in navigator) {
                commit("setLoadingInput", true);
                commit("setLoadingGeo", true);
                //commit("snackbar/setMensajeInfo", { msj: 'Estamos localizando tu posición' }, { root: true });
                navigator.geolocation.getCurrentPosition(function (position) {
                    let geocoder = new google.maps.Geocoder();
                    var coordinates = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    geocoder.geocode({
                        'location': coordinates
                    }, function (results, status) {
                        commit("setLoadingGeo", false);
                        if (status == 'OK') {
                            commit('setDirDomicilioGeoString', results[0].formatted_address);
                            commit('setDirDomicilioGeoObj', results[0]);
                            commit('setDirGeoCoordenadas', coordinates)
                            commit('setDirRecogerInputCoordenadas', coordinates)
                            commit("setDirRecogerInput", results[0].formatted_address);
                            commit("setDirRecogerInputObj", results[0]);
                            commit('setDirRecogerProveedor', 'geo');
                            commit("snackbar/reset", {}, { root: true });
                            dispatch('reorderRestaurants').finally(() => {
                                commit("setBuscando", false);
                                commit("setLoadingInput", false);
                                commit('setLoadingRest', false)
                            })
                        }

                    })
                }, function (error) {
                    commit("snackbar/setMensajeInfo", { msj: 'La localización no está activada' }, { root: true });
                    commit("setLoadingInput", false);
                    commit("setLoadingGeo", false);
                    commit('setLoadingRest', false)
                }, {
                    enableHighAccuracy: true
                });
            } else {
                commit('setLoadingRest', false)
            }
            /**
             * Uusario logueado que tiene direcciones almacenadas.
             * Se utiliza la úlitima que usó
             */
        } else {
            commit('setDirRecogerInputCoordenadas', {
                lat: ultimaDireccion.coordenadas[0],
                lng: ultimaDireccion.coordenadas[1]
            })
            commit("setDirRecogerInput", ultimaDireccion.formated);
            commit("setDirRecogerInputObj", ultimaDireccion);
            commit('setDirRecogerProveedor', 'input');
            commit('setLoadingRest', true)
            dispatch('reorderRestaurants').finally(() => {
                commit("setBuscando", false);
                commit("setLoadingInput", false);
                commit('setLoadingRest', false)
            })
        }
    },
    reorderRestaurants({ state, rootState, commit, dispatch }, data) {
        let _vue = this;
        let restaurantes = [];
        if (data != undefined) {
            restaurantes = data;
        } else {
            restaurantes = rootState.restaurante.listadoRestaurantes;
        }
        if (restaurantes.length > 0) {
            let position = state.dirRecogerInputCoordenadas;
            console.log(position);
            var promesas = [];
            restaurantes.forEach(function (e, i) {
                let payload = {
                    lat1: position.lat,
                    lon1: position.lng,
                    lat2: e.latitud,
                    lon2: e.longitud
                }
                promesas.push(dispatch('getDistanceLatLonInKm', payload)
                    .then((e) => {
                        restaurantes[i].distancia = e;
                    }))
            })
            Promise.all(promesas).then(() => {
                commit('restaurante/setListadoRestaurantes', restaurantes, { root: true })
                commit("setLocationEntries", [])
            })
        } else {

        }
    },
    getDistanceLatLonInKm({ state, commit }, data) {
        let p = Math.PI / 180;
        let cos = Math.cos;
        let restaLat = data.lat2 - data.lat1;
        let restaLong = data.lon2 - data.lon1;

        let a = 0.5 - cos((restaLat) * p) / 2 + cos(data.lat1 * p) * cos(data.lat2 * p) * (1 - cos((restaLong) * p)) / 2;
        let r = 12742 * Math.asin(Math.sqrt(a));

        return r;

    },
    cargarLogicaDomicilio({ rootGetters, rootState, dispatch }) {
        let ultimaDireccion = rootGetters['auth/ultimaDireccionUsada'];
        let isLogged = rootState.auth.isLogged;
        //commit("pedido/setNavigatorAddress", dirPidiendo, { root: true })
        if (!isLogged || !ultimaDireccion) {
            return dispatch('solicitarGeolocalizacionNavegador')
        }
    },
    pedirADireccion({ commit, rootState, state, dispatch }, payload) {
        let direccionObject = payload.dir != undefined ? payload.dir : null;
        const isPropio = rootState.propio.negocioPropio != null;
        if (direccionObject != null) {
            /*
                Si es una direccion de geolocalizacion abre modal para confirmar
                Si es una direccion de caché o perfil busca restaurante
            */
            if (direccionObject.tipo == 'geo') {
                //direccionObject.tipo = "geo-modal";
                commit('setDirDomicilioGeoObjCorregido', direccionObject);
                dispatch('openDialogDireccion', { open: true, dir: direccionObject })
                    .finally(function () {
                        commit("restaurante/setLoadingRest", false, { root: true });
                    });

            } else {
                commit("restaurante/setLoadingRest", false, { root: true });
                commit("pedido/setDireccionPedido", direccionObject, { root: true });
                dispatch("restaurante/filtradoRestaurantesDomicilio", {}, { root: true })
                    .then(data => {
                        if (data.length < 1) {
                            commit("snackbar/setMensajeInfo", { msj: 'No hay restaurante disponible para domicilio en la dirección indicada. \n Prueba a recoger u otra dirección' }, { root: true });
                        } else if (isPropio) {
                            return store.dispatch("pedido/elegirRestaurante", data[0].id)
                        }

                    })
                    .then(e => {
                    })
                    .catch(err => {
                    })
                    .finally(function () {
                        commit("restaurante/setLoadingRest", false, { root: true });
                        commit("setLoadingDireccionNavegador", false);
                    });
            }

        } else {
        }

    },
    openDialogDireccion({ commit, rootState, state }, payload) {
        let addressObject = {};
        var payloadDir = {};
        switch (payload.dir.tipo) {
            case 'input':
                payloadDir = state.dirDomicilioInputObj
                break;
            case 'geo':
                payloadDir = state.dirDomicilioGeoObjCorregido;
                break;

            default:
                payloadDir.tipo = 'noselocaliza';
                break;
        }
        commit("direcciones/setDirDomicilioDialogo", {
            ...payloadDir,
            tipo: 'modal-' + payloadDir.tipo

        }, { root: true });
        commit('setDialogoDomicilioDireccion', payload.open)

    },
    dialogoDireccionDomicilioToPedir({ state, commit, dispatch }) {
        let _vue = this;
        let payload = {};
        payload.dir = state.dirDomicilioDialogo;
        payload.dir.tipo
        commit(
            "setDirDomicilioCacheObj",
            state.dirDomicilioDialogo
        );
        commit("setDirDomicilioInput", "");
        state.dialogoDomicilioDireccion = true;
        state.loadingDialogDireccionDomicilio = true;
        dispatch('pedirADireccion', payload)
            .then(e => { })
            .finally(function () {
                state.dialogoDomicilioDireccion = false;
                state.loadingDialogDireccionDomicilio = false;
            });
    },
    comprobarDireccionNuevamente({ state, commit, dispatch }) {
        const dir = state.dirDomicilioDialogo;
        commit('setDirDomicilioDialogoOld', dir)
        let geocoder = new google.maps.Geocoder();
        const direccionAux = dir.calle + ' ' + dir.numero + ', ' + dir.municipio + ', ' + dir.provincia + ', ' + dir.cp;
        geocoder.geocode({
            'address': direccionAux,
            'componentRestrictions': { country: 'ES' }
        }, function (results, status) {
            if (status == 'OK') {
                commit('setDirDomicilioInput', (results[0] && results[0].formatted_address) ? results[0].formatted_address : '');
                commit("setBuscando", false);
                dispatch('reorderRestaurants').finally(() => {
                    commit('setDirDomicilioInputObj', {
                        ...formatearDireccionGoogle(results[0].address_components),
                        coordenadas: [results[0].geometry.location.lat(), results[0].geometry.location.lng()],
                        tipo: 'input-modal-comprobar'
                    });
                    commit("setBuscando", false);
                    commit("setDirDomicilioDialogSinCambios", true)
                })
            } else if (status === 'INVALID_REQUEST') {
                commit("setBuscando", false);
            } else {
                commit("setBuscando", false);
            };
        });
    },
    solicitarGeolocalizacionNavegador({ commit, state, dispatch }) {
        if ("geolocation" in navigator) {
            commit("setLoadingInput", true);
            commit("setLoadingGeo", true);
            //commit("snackbar/setMensajeInfo", { msj: 'Estamos localizando tu posición' }, { root: true });
            navigator.geolocation.getCurrentPosition(function (position) {
                let geocoder = new google.maps.Geocoder();
                var coordinates = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                geocoder.geocode({
                    'location': coordinates
                }, function (results, status) {
                    commit("setLoadingGeo", false);
                    if (status == 'OK') {
                        commit('setDirDomicilioGeoString', results[0].formatted_address);
                        commit('setDirDomicilioGeoObj', results[0]);
                        commit('setDirDomicilioGeoObjCorregido', {
                            ...formatearDireccionGoogle(results[0].address_components),
                            coordenadas: [results[0].geometry.location.lat(), results[0].geometry.location.lng()],
                            tipo: 'geo'
                        });
                        commit('setDirDomicilioGeoCoordenadas', coordinates)
                        commit("setLoadingInput", false);
                        commit("snackbar/reset", {}, { root: true });
                        commit('setLoadingRest', false)
                        dispatch('reorderRestaurants').then(() => {
                            commit('setLoadingRest', false)
                        }).catch((e) => consolee.log(e))
                        commit("setLoadingInput", false)
                    }

                })
            }, function (error) {
                commit("snackbar/setMensajeInfo", { msj: 'La localización no está activada' }, { root: true });
                commit("setLoadingInput", false);
                commit("setLoadingGeo", false);
            }, {
                enableHighAccuracy: true
            });
        } else {
            commit("setBuscando", false);
        }
    },
    //NUEVO

    codigo_postal_a_codigo_provincia({ commit, state, rootState }, payload) {
        return new Promise(async (resolve) => {
            let res;
            switch (payload.codigo_pais) {
                case 'ES':
                    res = Math.floor(parseInt(payload.cp) / 1000);
                    break;

                case 'DE':
                    res = Math.floor(parseInt(payload.cp) / 1000);
                    break;

                default:
                    res = null;
                    break;
            }

            resolve(res);
        })
    },
    direccionesCercanas({ rootState, state, dispatch }, coordIniciales) {
        let _vue = this;
        let cercano = -1;

        let direcciones = [];
        if (rootState.auth.user != undefined && rootState.auth.user != null && rootState.auth.user.direcciones != undefined && rootState.auth.user.direcciones != null) {
            direcciones = rootState.auth.user.direcciones;
        }

        let distanciaMinima = state.distanciaMinima;

        if (coordIniciales != undefined && direcciones.length > 0) {
            return new Promise(async (resolve) => {
                direcciones.forEach(async function (e, i, a) {
                    let payload = {
                        lat1: coordIniciales[0],
                        lon1: coordIniciales[1],
                    }
                    if (typeof (e.coordenadas) == 'string') {
                        payload['lat2'] = parseFloat(e.coordenadas.split(",")[0]);
                        payload['lon2'] = parseFloat(e.coordenadas.split(",")[1]);
                    } else {
                        payload['lat2'] = e.coordenadas[0]
                        payload['lon2'] = e.coordenadas[1]
                    }

                    await store.dispatch('pedido/getDistanceLatLonInKm', payload)
                        .then((distancia) => {
                            if (distancia < distanciaMinima) {
                                cercano = i;
                            }

                        })
                        .finally(function () {
                            resolve(cercano);
                        })

                })
            })
        } else {
            return -1;
        }
    },
    coordenadasCercanas({ state, dispatch }, coord) {
        let _vue = this;
        let cercano = -1;
        let distanciaMinima = store.state.direcciones.distanciaMinima;

        return new Promise(async (resolve) => {
            let payload = {
                lat1: coord[0][0],
                lon1: coord[0][1],
                lat2: coord[1][0],
                lon2: coord[1][1]
            }
            await store.dispatch('pedido/getDistanceLatLonInKm', payload)
                .then(async (distancia) => {
                    if (distancia < distanciaMinima) {
                        resolve("cercano")
                    } else {
                        resolve("lejano")
                    }
                })

        })

    },
    cargarDireccionNavegador({ commit, rootState, state, dispatch }) {
        let _vue = this;
        return new Promise((resolve) => {
            dispatch('pedido/getNavigatorLocation', null, { root: true })
                .then((data) => {
                    if (data == "error") {
                        commit("snackbar/setMensajeDanger", { msj: 'Debe activar la geolocalización si desea usarla' }, { root: true });
                        resolve("gps prohibido")
                    }
                    dispatch('pedido/geocodeCoordinatesToAddress', data, { root: true })
                        .then((data) => {
                            if (data.ok == "ok") {
                                data.direccion.geolocalizacion = true;
                                commit("direcciones/setDireccionNavegador", data.direccion, { root: true })

                                resolve("gps ok")
                            } else {
                                commit('snackbar/setMensajeInfo', {
                                    msj: 'Debe activar la geolocalización si desea usarla'
                                }, { root: true });
                                resolve("gps prohibido")
                            }
                        })

                })
        })
    },
    cargarDireccionCache({ commit, rootState, state, getters, dispatch }) {
        return new Promise((resolve) => {
            let cacheAddress = state.direccionCache;
            let isLogged = rootState.auth.isLogged;
            let _vue = this;

            if (isLogged) {
                dispatch('direccionesCercanas', cacheAddress.coordenadas)
                    .then((cerca) => {
                        if (cerca < 0 && Object.keys(cacheAddress).length > 0) {
                            commit("setDireccionCache")
                            resolve("cache ok")
                        } else {
                            resolve("cache cercano")
                        }
                    })

            } else {
                if (Object.keys(cacheAddress).length > 0) {
                    commit("setDireccionCache")
                    resolve("cache ok")
                } else {
                    resolve("cache cercano")
                }
            }

        })
    },
    localizarDireccion({ commit, rootState, state, dispatch, getters }) {
        let _vue = this;
        commit("setLoadingDireccionNavegador", true)

        return Promise.all([
            dispatch('cargarDireccionNavegador'),
            dispatch('cargarDireccionCache')
        ])
            .then((res) => {
                let coordCache = state.direccionCache.coordenadas;
                let coordNavegador = state.direccionNavegador.coordenadas;

                if (res[1] != "cache cercano") {
                    commit("pedido/setAddressObjectSinFiltro", state.direccionCache, { root: true })
                } else {
                    commit("pedido/setAddressObjectSinFiltro", state.direccionNavegador, { root: true })
                }

                commit("setMostrarDirCache", res[1] != "cache cercano");
                if (coordCache != undefined && coordNavegador != undefined) {
                    return Promise.all([
                        dispatch('coordenadasCercanas', [coordCache, coordNavegador]),
                        dispatch('direccionesCercanas', coordNavegador)
                    ])
                        .then((res) => {
                            let condicionDoble = res[0] == "lejano" && res[1] < 0;
                            commit("setMostrarDirNavegador", condicionDoble);
                        })
                        .catch((res) => {
                            console.log(res)
                        })
                        .finally(function () {
                        })

                }

            })
            .finally(function () {
                commit("setLoadingDireccionNavegador", false)
            })
    },
    generarDireccionDesdeCoordenadas({ commit, rootState, state, dispatch }, coordenadasIniciales) {
        let _vue = this;

        return new Promise(async (resolve) => {
            dispatch('pedido/geocodeCoordinatesToAddress', null, { root: true })
                .then((data) => {
                    let coordenadasFinales = data;

                    if (data.ok == "ok") {
                        if (coordenadasFinales[0] == coordenadasIniciales[0] && coordenadasFinales[1] == coordenadasIniciales[1]) {

                            let addr = formatearDireccionGoogle(data.direccion)
                            let numer = addr.numer != undefined ? ", " + addr.numer : '';
                            let cp = addr.cp != undefined ? ", " + addr.cp : '';
                            let provincia = addr.provincia != undefined ? ", " + addr.provincia : '';

                            let dirNav = addr;
                            dirNav["calle_numero"] = addr.calle + numer;
                            dirNav["datos_aux"] = addr.adicional;
                            dirNav["mun_cp_prov"] = addr.municipio + cp + provincia;
                            dirNav["geolocalizacion"] = true;
                            dirNav["coordenadas"] = coordenadasFinales;


                            commit("direcciones/setDireccionNavegador", dirNav, { root: true });
                            resolve("direccion ok")

                        } else {

                        }

                    } else {
                        commit('snackbar/setMensajeInfo',
                            { msj: 'Debe activar la geolocalización si desea usarla' },
                            { root: true });

                        resolve("error geolocalizacion")
                    }

                })
        })
    },
    eliminarDireccion({ commit, rootState }, id) {
        const uid = rootState.auth.user.uid;
        var dirs;
        return db.collection('users').doc(uid).get()
            .then((r) => {
                if (!r.exists) { return Promise.reject("No existe el usuario") }
                const d = r.data();
                const ref = r.ref;
                dirs = d.direcciones;
                if (!dirs) { return Promise.reject("No existen las direcciones") }
                const findIndex = dirs.findIndex(e => e.id == id);
                if (findIndex < 0) { return Promise.reject("No existe la dirección") }
                _.pullAt(dirs, findIndex);
                return ref.set({ direcciones: dirs }, { merge: true })
            })
            .then(() => {
                commit('auth/setDirecciones', dirs, { root: true })
            })
            .catch((e) => { return Promise.reject(e) })
    },
    editarDireccion({ commit, rootState }, obj) {
        const dir = obj;
    },
    resetInput({ commit, rootState }) {
        return new Promise(async (resolve) => {
            let res = "reset ok";
            commit('setAddressOnOpenDialog',
                {
                    calle: '',
                    numero: '',
                    adicional: '',
                    cp: '',
                    municipio: '',
                    provincia: '',
                    pais: '',
                    codigoPais: ''
                }
            );
            commit('setLocationSearchText', null);
            commit('setLocationEntries', []);
            commit('setBuscando', false);
            commit('setDireccionInput', null)

            resolve(res);
        })


    },
    resetRestaurantes({ commit, rootState }) {
        return new Promise(async (resolve) => {
            let res = "reset ok";
            commit('restaurante/resetRestaurante', '', { root: true });

            resolve(res);
        })

    },

    cargarLogicaDomicilio_old({ commit, rootState, state, dispatch }, payload) {
        let dirPidiendo = state.dirPidiendo ? state.dirPidiendo.formated : "";
        commit("pedido/setNavigatorAddress", dirPidiendo, { root: true })

        return Promise.all([
            dispatch('resetRestaurantes'),
            dispatch('resetInput')
        ])
            .then(function () { })
            .catch(function (e) {
                console.log("Error", e, "al reset restaurantes")
            })
            .finally(function () {
                return new Promise(async (resolve) => {
                    commit("setDireccionCache")
                    dispatch("localizarDireccion")
                        .then((e) => {
                            resolve("localizar direccion", e)
                            // _vue.autocompleteLocationModel = _vue.addressObject.formated;
                        });
                })
            });

    },
    pedirADireccion_old({ commit, rootState, state, dispatch }, payload) {
        let direccionObject = payload.dir != undefined ? payload.dir : null;
        if (direccionObject != null) {
            commit("restaurante/setLoadingRest", false, { root: true });

            /*
                Si es una direccion de geolocalizacion abre modal para confirmar
                Si es una direccion de caché o perfil busca restaurante
            */
            if (direccionObject.geolocalizacion != undefined) {
                dispatch('openDialogDireccion', { open: true, dir: direccionObject })
                    .finally(function () {
                        commit("restaurante/setLoadingRest", false, { root: true });
                    });

            } else {
                commit("pedido/setAddressObjectSinFiltro", direccionObject, { root: true });
                dispatch('loadAndOrderRestaurants')
                    .then(data => {
                        // dispatch('comprobarDireccion')
                        // .then(function(res) {

                        // })
                        // .finally(function() {
                        //     commit("restaurante/setLoadingRest", false, {root: true});
                        // })
                    })
                    .finally(function () {
                        commit("restaurante/setLoadingRest", false, { root: true });
                    });
            }

        } else {
            console.log("Direccion viene vacía")
        }

    },
    geocodeInput({ commit, rootState, state, dispatch }, event) {
        console.log("dentro");
        let _vue = this;
        let address = "";
        let locationEntries = state.locationEntries;
        let autocompleteLocationModel = rootState.pedido.navigatorAddress;

        let noselocaliza = false;
        if (locationEntries.length > 0) {
            noselocaliza = locationEntries[0]['value'].includes(
                "No se localiza. Escribir a mano."
            );
        }

        let modo = rootState.pedido.activePedido.forma_envio;

        return new Promise((resolve, reject) => {
            if (!state.buscando) {
                commit("setBuscando", true);
                let inputVacio = locationEntries[0] == undefined && !autocompleteLocationModel || locationEntries[0] == undefined && event == null;

                if (inputVacio) {
                    commit("snackbar/setMensajeDanger",
                        { msj: "No se localiza la dirección indicada" },
                        { root: true }
                    );
                    commit("setBuscando", false);
                    resolve("no se localiza")

                } else {

                    if (noselocaliza && modo == "domicilio") {
                        dispatch('openDialogDireccion', { open: true, dir: "No se localiza" })
                        commit("setBuscando", false);
                        resolve("abrir modal")

                    } else {

                        //Carga la direccion en el input si hay
                        if (event != undefined && event.value != undefined) {
                            address = event.value;
                            commit("pedido/setNavigatorAddress", event.value, { root: true });

                        } else if (locationEntries[0]) {
                            address = locationEntries[0].value;
                            commit("pedido/setNavigatorAddress", locationEntries[0].value, { root: true });
                        }

                        //Geolocaliza si la direccion no está vacía
                        if (address != "") {

                            store.dispatch("pedido/geocodeAddress", address)
                                .then(data => {
                                    commit("setDireccionInput", address);
                                    commit("pedido/setAddressObjectSinFiltro", data, { root: true });
                                    commit("setDireccionNavegador", data);

                                    if (modo == "domicilio") {
                                        //Sin modal para recoger
                                        dispatch('openDialogDireccion', { open: true, dir: null })
                                    } else {
                                        dispatch('loadAndOrderRestaurants')
                                    }

                                })
                                .then(() => {
                                    commit("setLocationEntries", []);
                                })
                                .catch(err => {
                                })
                                .finally(function () {
                                    commit("setBuscando", false);
                                    resolve("abrir modal")

                                });

                        } else {
                            commit("setBuscando", false);
                            resolve("La direccion está vacía")
                        }
                    }

                }
            }
        })
    },
    calcularGeolocalizacion({ commit, rootState, state, dispatch }, event) {
        return new Promise((resolve, reject) => {
            let _vue = this;
            let modo = rootState.pedido.activePedido.forma_envio;
            commit("setLoadingDireccionNavegador", true);

            store.dispatch("pedido/getNavigatorLocation")
                .then(data => {
                    if (data == "error") {
                        commit("snackbar/setMensajeDanger",
                            { msj: "Debe activar la geolocalización si desea usarla" },
                            { root: true }
                        );
                        resolve("Geolocalizacion desactivada")

                    } else {
                        store.dispatch("pedido/geocodeCoordinatesToAddress", data)
                            .then(data => {

                                if (data.ok == "ok") {
                                    commit("setDireccionNavegador", data.direccion);
                                    commit("pedido/setAddressObjectSinFiltro", data.direccion, { root: true });
                                    commit("pedido/setNavigatorAddress", data.direccion.formated, { root: true });

                                    if (modo == "domicilio") {
                                        dispatch('openDialogDireccion', { open: true, dir: null })
                                            .then(e => {
                                                resolve("Geolocalizacion ok en domicilio")
                                            })

                                    } else {
                                        dispatch('loadAndOrderRestaurants')
                                            .then(e => {
                                                resolve("Geolocalizacion ok en recoger")
                                            })
                                    }

                                } else {

                                    commit("snackbar/setMensajeInfo",
                                        { msj: "Debe activar la geolocalización si desea usarla" },
                                        { root: true }
                                    );
                                    resolve("Geolocalizacion desactivada")
                                }
                            });
                    }
                })
                .catch(err => {
                    reject("Error al geolocalizar", err)
                })
                .finally(function () {
                    commit("setLoadingDireccionNavegador", false);
                });
        })
    },

    loadAndOrderRestaurants_old({ commit, rootState, state, dispatch }) {
        let _vue = this;
        let modo = rootState.pedido.activePedido.forma_envio;
        let isPropio = rootState.propio.negocioPropio != null;
        let getRestaurantesAction = isPropio ? "propio/getListadoRestNegMix" : "restaurante/getListadoRestNegMix";

        commit("restaurante/setLoadingRest", true, { root: true });

        return new Promise((resolve, reject) => {

            store.dispatch(getRestaurantesAction)
                .then(data => {
                    store.dispatch("restaurante/reorderRestaurants", data)
                        .then(data => {
                            commit('restaurante/setListadoRestaurantes', data, { root: true })

                            if (modo == "recoger" && data.length < 0) {
                                commit("snackbar/setMensajeInfo",
                                    { msj: "No hay restaurantes por la zona" },
                                    { root: true }
                                );
                            }

                            if (modo == "domicilio") {

                            }
                        })
                        .finally(function () {
                            commit("restaurante/setLoadingRest", false, { root: true });
                            commit("setLoadingDireccionNavegador", false);
                            resolve("loadAndOrderFinishes")
                        });
                })
                .finally(function () {
                    commit("restaurante/setLoadingRest", false, { root: true });
                    commit("setLoadingDireccionNavegador", false);
                    resolve("loadAndOrderFinishes")
                });
        });
    },
};



